import { render, staticRenderFns } from "./StoriesTabLinks.vue?vue&type=template&id=38430ca5"
import script from "./StoriesTabLinks.vue?vue&type=script&lang=js"
export * from "./StoriesTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports